import moment from "moment";
import {
  getBookingWindow,
  getMaxBookingDate,
} from "../bookingapi/booking.operations";

export async function maxBookingDate(tmRef) {
  try {
    const bookingWindowData = await getBookingWindow();
    const bookingWindow = moment().add(bookingWindowData, "weeks");
    const maximumBookingDate = await getMaxBookingDate(tmRef);
    const closureDate = moment(maximumBookingDate);

    const closureDateYear = closureDate.get("year");

    if (closureDateYear === 2099) return closureDate.toDate();

    if (bookingWindow.isAfter(closureDate)) {
      return closureDate.toDate();
    } else {
      return bookingWindow.toDate();
    }
  } catch (error) {
    console.error(error);
    throw new Error("Failed to fetch maximum booking date");
  }
}
